import React, { useEffect, useState } from "react";
import { Col, Modal, Row, Form } from "react-bootstrap";
// import { Form } from 'react-router-dom';
import CloseSharpIcon from "@mui/icons-material/CloseSharp";
import { useParams } from "react-router-dom";
import toast from "react-hot-toast";
import axios from "../../API/axios";
import Flatpickr from "react-flatpickr";
import moment from "moment";

const UpdateEducationActivity = ({
  getUserCv,
  userDataId,
  handleCloseUpdateEducationActivity,
  showUpdateEducationActivity,
  educationData,
  educationActivityData,
  ActivityId,
}) => {
  console.log("educationActivityData", educationActivityData);
  console.log("educationData", educationData);

  const sessionId = localStorage.getItem("sessionId");
  const userType = localStorage.getItem("userType");
    const { CandidateId } = useParams();
  
  //   const { ActivityId } = useParams();
  const [activity, setActivity] = useState("");
  const [display, setDisplay] = useState(false);
  console.log("ActivityId", ActivityId);

  const [formChanged, setFormChanged] = useState(false); // Track if form is modified
  const [isSubmitting, setIsSubmitting] = useState(false);
  // Handle changes and mark form as modified
  const handleFieldChange = (setter, value) => {
    setter(value);
    // setFormChanged(true); // Enable Submit button
    setFormChanged(value.trim() !== ""); // Enable button only if input has value
  };

  
  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!formChanged || isSubmitting) return;
    setIsSubmitting(true); // Disable the button during submission
    setDisplay(true);
    const body = {
      sessionId: sessionId,
      userDataId: userDataId,
      userType: userType,
      instnCnddtID: CandidateId === "Candidate" ? null : CandidateId,
      // instnCnddtID: ActivityId === "null" ? null : ActivityId,
      eduId: educationData.usrDataEductnId,
      eduActvtyId: educationActivityData.usrDataEduActvtyId,
      activity: activity,
    };
    console.log("body", body);
    // if (achievement === "" || achievementtDate === "") {
    //   toast.error("Please fill all the required fields");
    // } else {
    try {
      const res = await axios.post("/Resume/UpdateEducationActivity", body);
      toast.success(res.data.message);
      handleCloseUpdateEducationActivity();
      getUserCv();
      setDisplay(false);
      setActivity(""); // Reset activity field
      setFormChanged(false); // Disable the button after update
    } catch (error) {
      if (error.response && error.response.status === 404) {
        toast.error(error.response.data.message);
      } else {
        toast.error(error.response?.data?.message || "An error occurred");
      }
    } finally {
      setIsSubmitting(false); // Re-enable the button after submission completes
    }
    // }
  };

  useEffect(() => {
    if (educationActivityData) {
      setActivity(educationActivityData.activity);
    }
  }, [educationActivityData]);

  return (
    <Modal
      show={showUpdateEducationActivity}
      onHide={handleCloseUpdateEducationActivity}
      centered
      size="lg"
    >
      <Modal.Header>
        <Modal.Title>Update education activity</Modal.Title>
        <CloseSharpIcon
          className="pointer"
          onClick={handleCloseUpdateEducationActivity}
        />
      </Modal.Header>
      <Modal.Body className="settings">
        <Row>
          <Col md={12}>
            <Form.Group controlId="grade">
              <Form.Label className="class-type">
                Activity{" "}
                <span style={{ color: "red" }}> *</span>
              </Form.Label>
              <Form.Control
                type="text"
                value={activity}
                // onChange={(e) => setActivity(e.target.value)}
                onChange={(e) => handleFieldChange(setActivity, e.target.value)} // Track changes
                placeholder="Enter Activity"
              />
              {display && !activity ? (
                <span className="error_msg_lbl">Add activity </span>
              ) : null}
            </Form.Group>
          </Col>
        </Row>

        <div className="d-flex justify-content-end mt-4">
          <div className="add-class-submit-button mt-4 d-flex justify-content-center">
            <div className="khojPrimaryBtn ms-3"
             onClick={handleSubmit}
             style={{cursor: formChanged ? "pointer" : "default"}}
            >
              <a href="#/"
                // onClick={handleSubmit}
                className={`btn ${!formChanged || isSubmitting ? "disabled" : "enabled"}`}
                // onClick={!formChanged || isSubmitting ? (e) => e.preventDefault() : handleSubmit}
                   //onClick={(e) => e.preventDefault()} 
                style={{ pointerEvents: formChanged ? "auto" : "none", border: "none" }}
              >
                {isSubmitting ? "" : "Submit"}
              </a>
            </div>
          </div>
        </div>
      </Modal.Body>
    </Modal>
  );
};

export default UpdateEducationActivity;
